import React from "react"
import CtaLink from "../../../../core/cta-link/CtaLink"
import { Link } from "gatsby"

const Button = ({
  aspect, // 'classique' or 'contrastant' or 'tag' or 'link' || 'unstyled'
  color, // ( 'primary' or 'secondary' or 'ternary' or 'annuler' or 'alerte' or for tag: 'alternate' ) || 'unstyled'
  size, // 'small' or 'medium' or 'large' || 'unstyled'
  onClick,
  to,
  href,
  className,
  activeclassname,
  ctalink,
  children,
  ...otherProps
}) => {
  color === "classique" && (color = "secondary")
  color === "contrastant" && (color = "primary")
  aspect === "Classique" && (aspect = "classique")
  aspect === "Contrastant" && (aspect = "contrastant")
  
  const buttonColor = [
    "primary",
    "secondary",
    "ternary",
    "annuler",
    "alerte",
    "alternate",
  ].includes(color)
    ? color
    : "unstyled"

  const Tag = ctalink ? CtaLink : to ? Link : href ? "a" : onClick ? "button" : "button"
  
  if (Tag === "button") {
    return (
      <button
        className={`${className || ""} ${aspect || ""} ${buttonColor || ""} ${size || ""}`}
        onClick={onClick ? onClick : undefined}
        {...otherProps}
      >
        {children}
      </button>
    )
  } else if (Tag === "a") {
    return (
      <a
        className={`button ${className || ""} ${aspect || ""} ${buttonColor || ""} ${size || ""}`}
        href={href}
        {...otherProps}
      >
        {children}
      </a>
    )
  } else if (Tag === Link) {
    return (
      <Link
        className={`button ${className || ""} ${aspect || ""} ${buttonColor || ""} ${size || ""}`}
        to={to}
        activeclassname={activeclassname}
        {...otherProps}
      >{children}</Link>
    )
  } else if (Tag === CtaLink) {
    return (
      <CtaLink
        className={`button ${className || ""} ${aspect || ""} ${buttonColor || ""} ${size || ""}`}
        ctaLink={ctalink}
        activeclassname={activeclassname}
        {...otherProps}
      >{children}</CtaLink>
    )
  } else {
        <Link
          className={`button ${className || ""} ${aspect || ""} ${buttonColor || ""} ${size || ""}`}
          to="/page-404"
          {...otherProps}
        >
          {children}
        </Link>
    }
}

export default Button
